<template>
    <el-dialog title="资源整编" width="35%" :close-on-click-modal="false" append-to-body :visible.sync="visible">
        <el-alert show-icon type="success"
                  :description="'已选择 '+ dataId.length +' 项资源'" :closable="false">
        </el-alert>
        <el-tabs v-model="activeName" @tab-click="selTab">
            <el-tab-pane label="位置替换" name="positionReplaceRuleMetadataFiled"></el-tab-pane>
            <el-tab-pane label="内容替换" name="contentReplaceRuleMetadataFiled"></el-tab-pane>
            <el-tab-pane label="著录项合并" name="combineRuleMetadataFiled"></el-tab-pane>
            <el-tab-pane label="生成序号" name="serialNumberRuleMetadataFiled"></el-tab-pane>
            <el-tab-pane label="自动补值" name="autoCompleteRuleMetadataFiled"></el-tab-pane>
        </el-tabs>
        <el-form size="small" :model="form" ref="form" label-width="120px" :rules="dataRule" v-loading="loading">
            <el-form-item label="著录项：" prop="basicCode" v-if="activeName != 'combineRuleMetadataFiled'">
                <el-select v-model="form.basicCode" placeholder="请选择需要替换的著录项" class="w100i" filterable clearable
                           @change="archivesChange">
                    <el-option
                            :key="item.basicCode"
                            :label="item.basicName"
                            :value="item.basicCode"
                            v-for="item in field[activeName]">
                    </el-option>
                </el-select>
            </el-form-item>
            <div v-if="activeName == 'positionReplaceRuleMetadataFiled'">
                <el-form-item label="替换位置：" prop="position1" class="perch">
                    <div class="flex_l_t">
                        <el-form-item prop="position1">
                            <el-input-number class="w100i" v-model="form.position1" :min="0" :max="form.basicAssemblyId && form.basicAssemblyId == '2' ? 2000 : 200"
                                             placeholder="请输入位置"></el-input-number>
                        </el-form-item>
                        <span class="p_l1 p_r1">至</span>
                        <el-form-item prop="position2">
                            <el-input-number class="w100i" v-model="form.position2" :min="0" :max="form.basicAssemblyId && form.basicAssemblyId == '2' ? 2000 : 200"
                                             placeholder="请输入位置"></el-input-number>
                        </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item label="替换成：" prop="newValue">
                    <el-input v-model.trim="form.newValue" placeholder="请输入需要替换成的内容" clearable maxlength="19"
                              @input="(v)=>(form.newValue=v.replace(/[^\d-.]/g,''))" v-if="form.basicAssemblyId == 12"></el-input>
                    <el-input v-model="form.newValue" placeholder="请输入需要替换成的内容"
                              :maxlength="form.basicAssemblyId && form.basicAssemblyId == '2' ? 2000 : 200" clearable
                              :rows="1"
                              :type="form.basicAssemblyId && form.basicAssemblyId == '2' ? 'textarea' : ''" v-else></el-input>
                </el-form-item>
            </div>
            <div v-if="activeName == 'contentReplaceRuleMetadataFiled'">
                <el-form-item label="替换内容：" prop="oldSubstr">
                    <!--数字-->
                    <el-input v-model.trim="form.oldSubstr" placeholder="请输入" clearable maxlength="19"
                              @input="(v)=>(form.oldSubstr=v.replace(/[^\d-.]/g,''))" v-if="form.basicAssemblyId == 12"></el-input>
                    <!--时间-->
                    <el-time-picker class="w100i" v-model="form.oldSubstr" placeholder="请选择"
                                    value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                    clearable v-else-if="form.basicAssemblyId == 8"></el-time-picker>
                    <!--日期-->
                    <el-date-picker class="w100i"
                                    v-model="form.oldSubstr" value-format="yyyy-MM-dd HH:mm:ss"
                                    :format="item.metadataBasicDataRuleVo ? item.metadataBasicDataRuleVo.ruleDateFormat : 'yyyy-MM-dd HH:mm:ss'"
                                    :type="setDatePickerType(item)"
                                    clearable placeholder="请选择"
                                    v-else-if="form.basicAssemblyId == 9"></el-date-picker>
                    <el-input v-model="form.oldSubstr" placeholder="请输入"
                              :maxlength="form.basicAssemblyId && form.basicAssemblyId == '2' ? 2000 : 200" clearable
                              :rows="1"
                              :type="form.basicAssemblyId && form.basicAssemblyId == '2' ? 'textarea' : ''" v-else></el-input>
                </el-form-item>
                <el-form-item label="替换成：" prop="newSubstr">
                    <!--数字-->
                    <el-input v-model.trim="form.newSubstr" placeholder="请输入" clearable maxlength="19"
                              @input="(v)=>(form.newSubstr=v.replace(/[^\d-.]/g,''))" v-if="form.basicAssemblyId == 12"></el-input>
                    <!--时间-->
                    <el-time-picker class="w100i" v-model="form.newSubstr" placeholder="请选择"
                                    value-format="yyyy-MM-dd HH:mm:ss" format="HH:mm:ss"
                                    clearable v-else-if="form.basicAssemblyId == 8"></el-time-picker>
                    <!--日期-->
                    <el-date-picker class="w100i"
                                    v-model="form.newSubstr" value-format="yyyy-MM-dd HH:mm:ss"
                                    :format="item.metadataBasicDataRuleVo ? item.metadataBasicDataRuleVo.ruleDateFormat : 'yyyy-MM-dd HH:mm:ss'"
                                    :type="setDatePickerType(item)"
                                    clearable placeholder="请选择"
                                    v-else-if="form.basicAssemblyId == 9"></el-date-picker>
                    <el-input v-model="form.newSubstr" placeholder="请输入"
                              :maxlength="form.basicAssemblyId && form.basicAssemblyId == '2' ? 2000 : 200" clearable
                              :rows="1"
                              :type="form.basicAssemblyId && form.basicAssemblyId == '2' ? 'textarea' : ''" v-else></el-input>
                </el-form-item>
            </div>
            <div v-if="activeName == 'combineRuleMetadataFiled'">
                <el-form-item label="著录项A：" prop="basicCodeA">
                    <el-select v-model="form.basicCodeA" placeholder="请选择" class="w100i" filterable clearable>
                        <el-option
                                :key="item.basicCode"
                                :label="item.basicName"
                                :value="item.basicCode"
                                v-for="item in field[activeName]">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="连接符号：" prop="connector">
                    <el-input v-model="form.connector" placeholder="请输入连接符号（- * / | 空格）" clearable
                              maxlength="1" @input="(v)=>(form.connector=v.replace(/[^-*/|\s]/g,''))"></el-input>
                </el-form-item>
                <el-form-item label="著录项B：" prop="basicCodeB">
                    <el-select v-model="form.basicCodeB" placeholder="请选择" class="w100i" filterable clearable>
                        <el-option
                                :key="item.basicCode"
                                :label="item.basicName"
                                :value="item.basicCode"
                                v-for="item in field[activeName]">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合并著录项C：" prop="basicCodeC">
                    <el-select v-model="form.basicCodeC" placeholder="请选择" class="w100i" filterable clearable>
                        <el-option
                                :key="item.basicCode"
                                :label="item.basicName"
                                :value="item.basicCode"
                                v-for="item in field[activeName].filter(v => v.basicAssemblyId != '8' && v.basicAssemblyId != '9')">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div v-if="activeName == 'serialNumberRuleMetadataFiled'">
                <el-form-item label="起始值：" prop="start">
                    <el-input v-model.trim="form.start" placeholder="请输入" clearable
                              maxlength="200"></el-input>
                </el-form-item>
                <el-form-item label="公差：" prop="step">
                    <el-input v-model.trim="form.step" placeholder="请输入" clearable
                              maxlength="200"></el-input>
                </el-form-item>
                <el-form-item label="格式：" prop="format">
                    <el-select v-model="form.format" placeholder="请选择" class="w100i" filterable clearable>
                        <el-option
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                v-for="item in $dictUtils.getDictList('reorganizeFormat')">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div v-if="activeName == 'autoCompleteRuleMetadataFiled'">
                <el-form-item label="补值方式：" prop="paddingType">
                    <el-radio-group v-model="form.paddingType" @input="form.fixedLength = ''">
                        <el-radio label="0">固定著录项长度</el-radio>
                        <el-radio label="1">固定补值</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="补值位置：" prop="paddingPosition">
                    <el-radio-group v-model="form.paddingPosition">
                        <el-radio label="0">著录项前面</el-radio>
                        <el-radio label="1">著录项后面</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="补值内容：" prop="paddingContent">
                    <el-input v-model.trim="form.paddingContent" placeholder="请输入" clearable
                              maxlength="200"></el-input>
                </el-form-item>
                <el-form-item label="固定长度：" prop="fixedLength" v-if="form.paddingType == '0'">
                    <el-input v-model.trim="form.fixedLength" placeholder="请输入" clearable
                              maxlength="200"></el-input>
                </el-form-item>
            </div>
        </el-form>
        <div slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" type="primary" :disabled="loading" @click="doSubmit()" v-noMoreClick>提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "reorganize",
        data() {
            var validatePosition = (rule, value, callback) => {
                let {position1, position2} = this.form
                if (value && position2 && position1 > position2) {
                    callback(new Error('请输入正确的位置数'));
                } else if (value && position1 && position2 < position1) {
                    callback(new Error('请输入正确的位置数'));
                } else {
                    this.$refs['form'].clearValidate(['position1', 'position2']);
                    callback();
                }
            };
            return {
                visible: false,
                loading: false,
                activeName: 'positionReplaceRuleMetadataFiled',
                dataId: [],
                basicDataId: '',
                configId: '',
                searchForm: {},
                form: {},
                item: {}, // 选中的元数据
                basicCodeOpt: [],
                dataRule: {
                    basicCode: [
                        {required: true, message: '元数据类型不能为空', trigger: 'change'}
                    ],
                    position1: [
                        {required: true, message: '替换位置不能为空', trigger: 'blur'},
                        {validator: validatePosition, trigger: 'blur'}
                    ],
                    position2: [
                        {required: true, message: '替换位置不能为空', trigger: 'blur'},
                        {validator: validatePosition, trigger: 'blur'}
                    ],
                    basicCodeA: [
                        {required: true, message: '元数据类型不能为空', trigger: 'change'}
                    ],
                    basicCodeB: [
                        {required: true, message: '元数据类型不能为空', trigger: 'change'}
                    ],
                    basicCodeC: [
                        {required: true, message: '元数据类型不能为空', trigger: 'change'}
                    ],
                    start: [
                        {required: true, message: '起始值不能为空', trigger: 'blur'}
                    ],
                    step: [
                        {required: true, message: '公差不能为空', trigger: 'blur'}
                    ],
                    format: [
                        {required: true, message: '格式不能为空', trigger: 'change'}
                    ],
                    paddingContent: [
                        {required: true, message: '补值内容不能为空', trigger: 'blur'}
                    ],
                },
                field: {},
            }
        },
        methods: {
            init(dataId, configId, basicDataId, searchForm) {
                this.selTab()
                this.activeName = 'positionReplaceRuleMetadataFiled'
                this.dataId = dataId
                this.configId = configId
                this.basicDataId = basicDataId
                this.searchForm = searchForm
                this.visible = true
                this.$nextTick(() => {
                    this.$refs.form.clearValidate()
                    this.getField()
                })
            },
            // 获取字段
            getField() {
                this.loading = true
                this.$axios(this.api.metadata.dataReorganizeFieldList, {
                    configId: this.configId,
                    basicDataId: this.basicDataId
                }).then(res => {
                    if (res.status) {
                        this.field = res.data
                    }
                    this.loading = false
                })
            },
            // 切换tab
            selTab() {
                this.form = {
                    basicCode: '',
                    position1: undefined,
                    position2: undefined,
                    newValue: '',
                    newSubstr: '',
                    oldSubstr: '',
                    basicCodeA: '',
                    connector: '',
                    basicCodeB: '',
                    basicCodeC: '',
                    start: '',
                    step: '',
                    format: '',
                    paddingType: '0',
                    paddingPosition: '',
                    paddingContent: '',
                    fixedLength: '',
                }
            },
            // 选择著录项
            archivesChange() {
                this.form.position1 = undefined
                this.form.position2 = undefined
                this.form.newValue = ''
                this.form.oldSubstr = ''
                this.form.newSubstr = ''
                if (this.form.basicCode) {
                    let val = this.field[this.activeName].filter(v => v.basicCode == this.form.basicCode)[0]
                    this.$set(this.form, 'basicAssemblyId', val.basicAssemblyId)
                    this.$set(this.item, 'metadataBasicDataRuleVo', val.metadataBasicDataRuleVo)
                } else {
                    this.$set(this.form, 'basicAssemblyId', '')
                    this.$set(this.item, 'metadataBasicDataRuleVo', {})
                }
            },
            // 表单提交
            doSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        if(this.activeName == 'contentReplaceRuleMetadataFiled' && (!this.form.oldSubstr && !this.form.newSubstr)) {
                            this.$message.warning('“替换内容”和“替换成”至少输入一项!')
                            return
                        }
                        this.loading = true
                        let p = {
                            configId: this.configId,
                            basicDataId: this.basicDataId,
                            dataId: this.dataId,
                            reorganizeRuleCollections: {},
                            selectArchivesDataElasticsearch: this.searchForm
                        }
                        let type = this.activeName.replace("MetadataFiled", "")
                        p.reorganizeRuleCollections[type] = this.form
                        this.$axios(this.api.metadata.dataReorganize, p, 'post').then(data => {
                            if (data.status) {
                                this.$message.success('提交成功')
                                this.visible = false
                                this.$emit('refreshData')
                            } else {
                                this.$message.error(data.msg)
                            }
                            this.loading = false
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .perch {
        margin-bottom: 0 !important;
    }

    ::v-deep .el-input-number--small .el-input-number__decrease, ::v-deep .el-input-number--small .el-input-number__increase {
        display: none !important;
    }

    ::v-deep .el-input-number .el-input__inner {
        text-align: left !important;
        padding: 0 15px !important;
    }
</style>
